
import { onMounted, reactive, ref } from 'vue'
import Button from '@/components/elements/Button.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import FormSelectField from '@/components/block/FormSelectField.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { useRouter } from 'vue-router'

export default {
  props: {
    answer: Number,
    answer_comment: String,
  },

  name: 'MypageLeaveInput',

  components: {
    Button,
    HeadingLv1,
  },

  setup(props: any) {
    const router = useRouter()
    const state = reactive<any>({
      enableRequest: false,
      hasRequestableHospital: false,
      isLoading: true
    })

    const csrf = ref(
      document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')
    )

    interface SelectObject {
      label: string
      value: string
      selected: boolean
    }

    const selectDefault = {
      label: '選択してください',
      value: '',
      selected: false
    }

    const confirm = () => {
      router.push('/');
    }

    onMounted(() => {
      const getList = axiosSetting('app', 'page')
    })

    return {
      csrf,
      state,
      FormSelectField,
      confirm,
    }
  }
}
